import { ReactElement } from "react";

import styles from "./index.module.css";
import { useNavigate } from "../../../lib/navigate";
import IconButton from "../Icon/Button";

export default function Header(
  props: {
    title?: string;
    nav?: ReactElement;
  } & (
    | {
        menu?: ReactElement;
      }
    | {
        modal?: boolean;
      }
  )
): ReactElement {
  const navigate = useNavigate();
  const isModal = "modal" in props && props.modal;

  return (
    <header
      className={`${styles.header} ${props.title ? styles.threeCols : ""}`}
    >
      {!isModal ? (
        <div className={styles.nonModalNav}>
          {props.nav ?? (
            <IconButton name={"left"} onClick={() => navigate("/")} />
          )}
        </div>
      ) : undefined}

      {props.title ? <p className={styles.title}>{props.title}</p> : undefined}

      {"menu" in props && props.menu ? (
        <section className={styles.menu}>{props.menu}</section>
      ) : undefined}

      {isModal
        ? props.nav ?? (
            <IconButton name={"close"} onClick={() => navigate(-1)} />
          )
        : undefined}
    </header>
  );
}
